import React, { createContext, useState, useContext, useEffect } from 'react';

// Create the language context
const LanguageContext = createContext();

// Available languages
export const languages = {
  EN: 'en',
  FR: 'fr',
  ES: 'es',
  TR: 'tr'
};

// Language provider component
export const LanguageProvider = ({ children }) => {
  // Get initial language from localStorage or use Turkish as default
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage || languages.TR;
  });

  // Update localStorage when language changes
  useEffect(() => {
    localStorage.setItem('language', currentLanguage);
  }, [currentLanguage]);

  // Function to change the language
  const changeLanguage = (language) => {
    if (Object.values(languages).includes(language)) {
      setCurrentLanguage(language);
    }
  };

  // Context value
  const value = {
    currentLanguage,
    changeLanguage,
    languages
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook to use the language context
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
